var scope_0 = require('/opt/build/repo/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/34f0915949df0bc886a91c79a30fa4af.js').default;export default
        Object.assign({}, scope_0 )
    